import Vue from 'vue';
import Component from 'vue-class-component';
import Flatpickr from "flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import ShortcutButtonsPlugin from "shortcut-buttons-flatpickr"
import { Prop, Watch } from 'vue-property-decorator';
import { Icon } from '../icon/icon';
import { addDays } from 'date-fns'

require('wc-lib/icons/calendar.svg');

export interface IWcDatepicker {
    pickedDate: Date
    pickedToDate: Date
    hasErrors: boolean
    errorList: Array<string>
}

@Component({
    template: require('./datepicker.html'),
    name: 'wc-datepicker',
    components: {
        'wc-icon': Icon
    }
})
export class WcDatepicker extends Vue {

    private getButtonsPluginConfig(inputType: string) {

        return {
            button: [
                {
                    label: "Today"
                }
            ],
            label: "",
            onClick: (index, fp) => {
                let today;
                switch (index) {
                    case 0:
                        let d = new Date();
                        let dy = d.getDate();
                        let y = d.getFullYear();
                        let m = d.getMonth();
                        today = new Date(y, m, dy);
                        break;
                }
                fp.setDate(today);
                const changeDate = this.returnDateObject();
                if (inputType == "from") {
                    const changePickedDate = changeDate.pickedDate ? changeDate.pickedDate.valueOf() : 0;
                    const currentPickedDate = this.value.pickedDate ? this.value.pickedDate.valueOf() : 0;
                    if (currentPickedDate !== changePickedDate)
                        this.$emit('input', changeDate);
                } else {
                    this._errorList = [];
                    if ((this.enableValidation) && (this.fp2.selectedDates[0] as Date) && (this.fp.selectedDates[0] as Date)) {
                        let diff = (this.fp2.selectedDates[0] as Date).valueOf() - (this.fp.selectedDates[0] as Date).valueOf();
                        if (diff < 0) {
                            this._errorList.push('From date cannot be after to date.');
                        }
                    }
                    const changePickedDate = changeDate.pickedToDate ? changeDate.pickedToDate.valueOf() : 0;
                    const currentPickedDate = this.value.pickedToDate ? this.value.pickedToDate.valueOf() : 0;
                    if (currentPickedDate !== changePickedDate)
                        this.$emit('input', changeDate);
                }
            }
        };
    }
    @Prop()
    value: IWcDatepicker;

    @Prop({
        default: null
    })
    defaultDate: Date;

    @Prop({
        default: null
    })
    defaultToDate: Date;

    @Prop({
        default: false
    })
    enableTime: boolean;

    @Prop({
        default: true
    })
    enableValidation: boolean;

    @Prop({
        default: null
    })
    minDate: Date;

    @Prop({
        default: null
    })
    maxRangeDays: number;

    @Prop({
        default: false
    })
    allowInput: boolean;

    @Prop({
        default: false
    })
    isRange: boolean;

    @Prop({
        default: false
    })
    showWeekNumbers: boolean;

    @Prop({
        default: null
    })
    weekNumberStart: string | Function;

    @Prop({
        default: true
    })
    showTodayButton: boolean;

    @Prop({
        default: false
    })
    allowNullInitialisation: boolean;

    @Prop({
        default: false
    })
    monthPicker: boolean;

    @Prop({
        default: false
    })
    disabled: boolean;

    @Prop({
        default: "from..."
    })
    placeholderFrom: string;

    @Prop({
        default: "to..."
    })
    placeholderTo: string;


    @Watch('value', { deep: true })
    updateValue() {
        let d = new Date();
        let dy = d.getDate();
        let y = d.getFullYear();
        let m = d.getMonth();

        let defaultDt = (this.defaultDate || this.allowNullInitialisation) ? this.defaultDate : new Date(y, m, dy);
        let defaultToDt = (this.defaultToDate || this.allowNullInitialisation) ? this.defaultToDate : new Date(y, m, dy);

        this._pickedDate = this.value && this.value.pickedDate ? new Date(this.value.pickedDate || defaultDt) : defaultDt;
        if (this.isRange)
            this._pickedToDate = this.value && this.value.pickedToDate ? new Date(this.value.pickedToDate || defaultToDt) : defaultToDt;

        this._errorList = [];

        // sanity check for nulls
        if(this.value && this.value.pickedDate){
            // sync input fields to set date
            if (this.fp && this._pickedDate !== this.value.pickedDate)
                this.fp.setDate(this._pickedDate, false, this.dateFormat);
            // only update pickedToDate if isRange
            if (this.fp2 && this.isRange && this._pickedToDate !== this.value.pickedToDate) {
                this.fp2.setDate(this._pickedToDate, false, this.dateFormat);
            }
        }
    }

    static getEmptyIWcDatepicker(): IWcDatepicker {
        return { pickedDate: new Date(), pickedToDate: new Date(), hasErrors: false, errorList: [] };
    }

    dateFormat: string = "d/m/Y";
    fp: any = null;
    fp2: any = null;

    _pickedDate: Date;
    _pickedToDate: Date;
    _errorList: string[];

    onButtonClick(e) {
        this.fp.open(e);
    }

    returnDateObject(): IWcDatepicker {

        if (this.fp.selectedDates[0]) {
            this._pickedDate = this.fp.selectedDates[0] as Date;
            if (this.isRange && this.fp2 && this.fp2.selectedDates[0]) {
                this._pickedToDate = this.fp2.selectedDates[0] as Date;
            }
        }
        return {
            pickedDate: this._pickedDate
            , pickedToDate: this._pickedToDate
            , hasErrors: ((this._errorList) && (this._errorList.length > 0))
            , errorList: this._errorList
        }
    }

    clear(){
        let changeDate:any = this.returnDateObject();
        // sync ui
        this.fp.clear();
        this.fp.close();
        // syn model
        changeDate.pickedDate = null;
        this.$emit('input', changeDate);
    }

    initialise() {
        this.updateValue();
        let e: HTMLElement = this.$refs["dt-p"] as HTMLElement;
        let config:any = {
            plugins: [
                (this.showTodayButton && !this.monthPicker) ? ShortcutButtonsPlugin(this.getButtonsPluginConfig("from")) : undefined,
                this.monthPicker ? monthSelectPlugin() : undefined
            ].filter(plugin => plugin != undefined)
            , enableTime: this.enableTime
            , dateFormat: this.dateFormat //"Y-m-d H:i"
            , defaultDate: this._pickedDate
            , minDate: this.minDate
            , allowInput: this.allowInput
            , clickOpens: true
            , time_24hr: true
            , defaultHour: 0
            , weekNumbers: this.showWeekNumbers
            , onChange: (selectedDates, dateStr) => {
                const changeDate:any = this.returnDateObject();
                // reset value to null
                if(dateStr === '' && changeDate.pickedDate){
                    changeDate.pickedDate = null;
                    this.$emit('input', changeDate);
                } else if(dateStr){
                    const changePickedDate = changeDate.pickedDate ? changeDate.pickedDate.valueOf() : 0;
                    const currentPickedDate = this.value.pickedDate ? this.value.pickedDate.valueOf() : 0;
                    // only update value if it is different
                    if (currentPickedDate !== changePickedDate)
                        this.$emit('input', changeDate);
                }
            }
            , onClose: () => {
                if (this.isRange) {
                    if (this.fp.selectedDates[0]) {
                        this.$set(this.fp2.config, 'minDate', this.fp.selectedDates[0] as Date);
                        if (this.maxRangeDays) {
                            let mxDate = addDays(this.fp.selectedDates[0] as Date, this.maxRangeDays);
                            this.$set(this.fp2.config, 'maxDate', mxDate);
                        }

                        if (this.monthPicker) {
                            let ev = document.createEvent('MouseEvents');
                            ev.initEvent('mousedown', true, true);
                            this.fp2.nextMonthNav.dispatchEvent(ev);
                            this.fp2.prevMonthNav.click();
                        }
                    }
                    this.fp2.open();
                }
            }
        };

        // sanity check otherwise default to flatpickr
        if(this.weekNumberStart){
            // load custom formatter
            if(typeof this.weekNumberStart === 'function'){
                config.getWeek = this.weekNumberStart;
            } else {
                //use inbuilt formatter
                const weekDays = ['sun','mon','tue','wed','thu','fri','sat'];
                let getDayNumber = (dayName) => {
                    let weekDayNumber = 0;
                    // set start week
                    weekDays.forEach((day, index) => {
                        // do case insensitve comparison and long names match
                        if(dayName.toLowerCase().indexOf(day.toLowerCase()) === 0){
                            weekDayNumber = index;
                        }
                    });
                    return weekDayNumber;
                }
                config.getWeek = date => {
                    // defaults to first day of year
                    let yearStart = new Date(date.getFullYear(), 0, 1);
                    // Copy date so don't modify original
                    let dateWeek = new Date(date);
    
                    // offset by day for first month
                    if(this.weekNumberStart !== 'first'){
                        let curDayNumber = getDayNumber(this.weekNumberStart);
                        if(curDayNumber < yearStart.getDay()){
                            // calculate last year
                            if(date.getMonth() === 0 && date.getDate() === 1){
                                dateWeek.setDate(yearStart.getDate() - 1);
                                yearStart.setFullYear(yearStart.getFullYear() - 1);
                                return  Math.ceil((((dateWeek.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
                            }
                            yearStart.setDate(yearStart.getDate() + (7 + curDayNumber - yearStart.getDay()));
                        }else{
                            yearStart.setDate(yearStart.getDate() + (curDayNumber - yearStart.getDay()));
                        }
                    } else {
                        let isNewYearStart = new Date(date);
                        isNewYearStart.setDate(isNewYearStart.getDate() + (6 - dateWeek.getDay()));
                        // override dec to jan transition if next year
                        if(isNewYearStart.getFullYear() > yearStart.getFullYear()){
                            yearStart = new Date(isNewYearStart.getFullYear(), 0, 1);
                        }
                    }
                    // offset to next week if year starts later in the week
                    if(dateWeek.getDay() < yearStart.getDay()){
                        dateWeek.setDate(dateWeek.getDate() + yearStart.getDay() - dateWeek.getDay());
                    }
                    // add one to offset array 0
                    return Math.floor((((dateWeek.getTime() - yearStart.getTime()) / 86400000)) / 7) + 1;
                }
            }
        }

        this.fp = Flatpickr(e, config);
        let dis = this;
        if (this.monthPicker) {
            this.fp.nextMonthNav.addEventListener('mousedown', function (e) { e.stopPropagation(); });
            this.fp.prevMonthNav.addEventListener('mousedown', function (e) { e.stopPropagation(); });
        }
        e.addEventListener("blur", function () {
            let x: any = e;
            let xx = x._flatpickr;
            if (dis.allowInput == true && xx.selectedDates[0] && (xx.selectedDates[0] as Date).toLocaleDateString() != (xx.element.value)) {
                xx.setDate(xx.element.value, true, dis.dateFormat);
            }
        });
        
        // event for null values
        e.addEventListener("keyup", function(curEvent:any) {
            let dateStr = curEvent.target.value;
            const changeDate = dis.returnDateObject();
            // only clear if change is '' and pickedDate is not null
            if (dateStr === '' && changeDate.pickedDate) {
                dis.clear();
            } else {
                let regDate = '^([0][1-9]|[1-2][0-9]|[3][0-1])/([0][1-9]|[1][0-2])/[0-9][0-9][0-9][0-9]';
                if(dis.enableTime){
                    regDate += '\ ([0-1][0-9]|2[0-4]):([0-5][0-9])$';
                }
                const regex = new RegExp(regDate);
                let isCorrectFormat = regex.test(dateStr);
                if (isCorrectFormat){
                    let listDateVal = dateStr.split('/');
                    if(dis.enableTime){
                        // extract time from dateFormat
                        let temp = listDateVal[2].split(' ');
                        listDateVal[2] = temp[0];
                        // only assign time if time is valid format h:m
                        temp = temp[1].split(':');
                        if(temp.length === 2){
                            listDateVal = listDateVal.concat(temp);
                        }
                    } else {
                        // default time to 00:00
                        listDateVal = listDateVal.concat(['00','00']);
                    }
                    let d = new Date(listDateVal[2], Number(listDateVal[1]) - 1, listDateVal[0], Number(listDateVal[3]), Number(listDateVal[4]));
                    // sanity check conversion is working correctly
                    const isValidDate = (d && (d.getMonth() + 1) === Number(listDateVal[1]) && d.getDate() === Number(listDateVal[0]) && d.getFullYear() === Number(listDateVal[2]), d.getHours() === Number(listDateVal[3]), d.getMinutes() === Number(listDateVal[4]));
                    if (isValidDate){
                        // only update value if date is valid and has changed since last valid date
                        if (changeDate.pickedDate !== d){
                            dis.fp.close();
                            changeDate.pickedDate = d;
                            dis.$emit('input', changeDate);
                        }
                    }
                }
            }

        });

        if (this.isRange) {
            let e2: HTMLElement = this.$refs["dt-p2"] as HTMLElement;
            if (this._pickedToDate < this._pickedDate)
                this._pickedToDate = this._pickedDate;
            this.fp2 = Flatpickr(e2, {
                plugins: [
                    (this.showTodayButton && !this.monthPicker) ? ShortcutButtonsPlugin(this.getButtonsPluginConfig("to")) : undefined,
                    this.monthPicker ? monthSelectPlugin() : undefined
                ].filter(plugin => plugin != undefined)
                , enableTime: this.enableTime
                , dateFormat: this.dateFormat //"Y-m-d H:i"
                , defaultDate: this._pickedToDate
                , minDate: this.minDate
                , allowInput: this.allowInput
                , clickOpens: true
                , time_24hr: true
                , weekNumbers: this.showWeekNumbers
                , onChange: (selectedDates, dateStr, instance) => {
                    this._errorList = [];
                    if ((this.enableValidation) && (this.fp2.selectedDates[0] as Date) && (this.fp.selectedDates[0] as Date)) {
                        let diff = (this.fp2.selectedDates[0] as Date).valueOf() - (this.fp.selectedDates[0] as Date).valueOf();
                        if (diff < 0) {
                            this._errorList.push('From date cannot be after to date.');
                        }
                    }
                    const changeDate = this.returnDateObject();
                    const changePickedDate = changeDate.pickedToDate ? changeDate.pickedToDate.valueOf() : 0;
                    const currentPickedDate = this.value.pickedToDate ? this.value.pickedToDate.valueOf() : 0;
                    if (currentPickedDate !== changePickedDate)
                        this.$emit('input', changeDate);
                }
            });
            if (this.monthPicker) {
                this.fp2.nextMonthNav.addEventListener('mousedown', function (e) { e.stopPropagation(); });
                this.fp2.prevMonthNav.addEventListener('mousedown', function (e) { e.stopPropagation(); });
            }
            e2.addEventListener("blur", function () {
                let x: any = e2;
                let xx = x._flatpickr;
                if (dis.allowInput == true && xx.selectedDates[0] && (xx.selectedDates[0] as Date).toLocaleDateString() != (xx.element.value)) {
                    xx.setDate(xx.element.value, true, 'd/m/Y');
                }
            })
        }
        this.$emit('input', this.returnDateObject());
    }

    mounted() {
        if (this.enableTime) {
            this.dateFormat = "d/m/Y H:i";
        }
        this.initialise();
    }

}



// WEBPACK FOOTER //
// src/../~/wc-lib/src/wc-ui/components/datepicker/datepicker.ts